import type { IPagination } from '@/interfaces'
import { DEFAULT_PAGE_LIMIT, DEFAULT_PAGE_OFFSET } from '@/utils/constants'

export default <IPagination>{
  offset: DEFAULT_PAGE_OFFSET,
  limit: DEFAULT_PAGE_LIMIT,
  currentPageSize: 0,
  responseRowCount: 0,
  loading: true,
  totalRowCount: 0,
  noData: false,
  data: null,
  filtersOptions: {},
  selectedItems: null,
  isAllListItemsSelected: false,
  isSelectedAllSnackbarItems: false,
  scrollPosition: { x: 0, y: 0 },
  failed: false,
  cookie: null,
  temporarySelectedItems: null,
  selectedItemsData: null,
  limitItems: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  selectedPageNumber: 1
}
